import { render, staticRenderFns } from "./ManageTeamRolesPage.vue?vue&type=template&id=3774d7b8&scoped=true"
import script from "./ManageTeamRolesPage.vue?vue&type=script&lang=ts"
export * from "./ManageTeamRolesPage.vue?vue&type=script&lang=ts"
import style0 from "./ManageTeamRolesPage.vue?vue&type=style&index=0&id=3774d7b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774d7b8",
  null
  
)

export default component.exports